module.exports = __webpack_public_path__ + "static/media/MasterCard-light.a7aaaa2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/MasterCard-light.svg
// module id = 252
// module chunks = 0